import { BrowserRouter, Routes, Route, ScrollRestoration } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import BrandPage from './pages/BrandPage';
import ProductCategoryPage from './pages/ProductCategoryPage';
import './index.css';

function ScrollToTop() {
  // Simple scroll to top on route change
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/brands/:brandSlug" element={<BrandPage />} />
          <Route path="/brands/:brandSlug/:categorySlug" element={<ProductCategoryPage />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
